import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function AuthorPopover({ author, children }) {
  const navigate = useNavigate();
  
  // scholar_id 또는 author_id 중 사용 가능한 것 사용 (0도 유효한 값이므로 명시적 체크)
  const scholarId = (author?.scholar_id != null && author.scholar_id !== '' && author.scholar_id !== '0')
    ? author.scholar_id
    : (author?.author_id != null && author.author_id !== '' && author.author_id !== '0')
      ? author.author_id
      : null;

  // ID 정보 추출
  const ids = Array.isArray(author?.research_ids) ? author.research_ids : [];
  const findId = (t) => {
    try {
      const it = ids.find(r => r?.id_type === t);
      return it?.id_value || '';
    } catch (e) {
      return '';
    }
  };
  // ID 값 추출 (빈 문자열과 null 체크)
  const orcid = (author?.orcid && String(author.orcid).trim()) || (findId('orcid') && String(findId('orcid')).trim()) || '';
  const researcherId = (author?.researcher_id && String(author.researcher_id).trim()) || (findId('researcher_id') && String(findId('researcher_id')).trim()) || '';
  const googleId = (author?.googlescholar_id && String(author.googlescholar_id).trim()) || (findId('googlescholar_id') && String(findId('googlescholar_id')).trim()) || (findId('google_scholar_id') && String(findId('google_scholar_id')).trim()) || '';
  const isni = (author?.isni && String(author.isni).trim()) || (findId('isni') && String(findId('isni')).trim()) || '';

  const orcidUrl = orcid ? `https://orcid.org/${orcid}` : '';
  const researcherIdUrl = researcherId ? `https://www.researcherid.com/rid/${researcherId}` : '';
  const googleUrl = googleId ? `https://scholar.google.com/citations?user=${encodeURIComponent(googleId)}` : '';
  const isniUrl = isni ? `https://nl.go.kr/isni/${isni}` : '';
  const pnuUrl = scholarId != null ? `${rmVars.homeUrl}/researchers/${encodeURIComponent(scholarId)}` : '';

  // scholar_id 또는 author_id가 있으면 ID 마크 표시
  // const hasId = scholarId != null;
  const hasId = (scholarId != null) && (orcid || researcherId || googleId || isni);

  if (!hasId) {
    const handleClick = (e) => {
      if (scholarId != null) {
        e.preventDefault();
        navigate(`/researchers/${encodeURIComponent(scholarId)}`);
      }
    };
    
    return <span className="flex items-center gap-1 pt-[4px]">
      {pnuUrl ? (
        <a 
          href={`${pnuUrl}`} 
          onClick={handleClick}
          className="hover:underline underline-offset-2 decoration-1 cursor-pointer"
        >
          {children}
        </a>
        ) : (
        children
        )
      }
    </span>;
  }

  const handleClick = (e) => {
    if (scholarId != null) {
      e.preventDefault();
      navigate(`/researchers/${encodeURIComponent(scholarId)}`);
    }
  };

  return (
    <div className="relative flex items-center gap-1 pt-[4px]">
      {pnuUrl ? (
        <a 
          href={`${pnuUrl}`} 
          onClick={handleClick}
          className="hover:underline underline-offset-2 decoration-1 cursor-pointer"
        >
          {children}
        </a>
      ) : (
        children
      )
      }
      <div className="relative group flex items-center">
        <img
          src={`${rmVars.themeUrl}images/id-mark.png`}
          className="w-[18px] h-[18px]"
          alt="id mark"
        />
        {/* 마크 호버시 팝업 - 상단에 투명 패딩 추가로 브릿지 역할 */}
        <div
          className="id-hover flex hidden absolute bottom-[calc(100%+15px)] left-[50%] translate-x-[-50%] flex-col gap-[6px] bg-white border border-[#E4E8F1] shadow-[0px_4px_20px_rgba(0,0,0,0.1)] rounded-[12px] pt-[20px] pb-4 px-4 after:content-[''] after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:w-0 after:h-0 after:border-l-[8px] after:border-l-transparent after:border-r-[8px] after:border-r-transparent after:border-t-[8px] after:border-t-[#E4E8F1] before:content-[''] before:absolute before:top-[calc(100%-1px)] before:left-1/2 before:-translate-x-1/2 before:w-0 before:h-0 before:border-l-[7px] before:border-l-transparent before:border-r-[7px] before:border-r-transparent before:border-t-[7px] before:border-t-white after:z-0 before:z-[1] group-hover:flex hover:flex"
          style={{ pointerEvents: 'auto' }}
          onMouseDown={(e) => { try { e.stopPropagation(); } catch { } }}
          onClick={(e) => { try { e.stopPropagation(); } catch { } }}
        >
          {/* 트리거 ↔ 팝업 사이의 빈 공간(15px) 브릿지: 이동 중에도 hover 유지 */}
          <div className="absolute left-0 right-0 -bottom-[15px] h-[15px] bg-transparent" />
          {pnuUrl && (
            <div className="w-[158px] bg-[#ECF2FF] rounded-[12px] p-[6px]" style={{ pointerEvents: 'auto' }}>
              <Link
                to={pnuUrl}
                className="flex items-center gap-[5px]"
                onMouseDown={(e) => { try { e.stopPropagation(); } catch { } }}
                onClick={(e) => { try { e.stopPropagation(); } catch { } }}
              >
                <img
                  src={`${rmVars.themeUrl}images/pnu-page.png`}
                  className="w-[21px] h-[21px]"
                  alt="pnu icon"
                />
                <span className="text-[12px] text-[#376BDB] font-semibold">PNU Scholar Page</span>
              </Link>
            </div>
          )}
          {orcidUrl && (
            <div className="relative w-[158px] bg-[#F3F5F9] rounded-[12px] p-[6px]" style={{ pointerEvents: 'auto' }}>
              <a
                href={orcidUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[5px]"
                onMouseDown={(e) => { try { e.stopPropagation(); } catch { } }}
                onClick={(e) => { try { e.stopPropagation(); } catch { } }}
              >
                <img
                  src={`${rmVars.themeUrl}images/orcid-page.png`}
                  className="w-[21px] h-[21px]"
                  alt="orcid icon"
                />
                <span className="text-[12px] text-[#555] font-semibold">ORCID</span>
                <img
                  src={`${rmVars.themeUrl}images/launch-ico-555.png`}
                  className="absolute right-[6px] top-[50%] translate-y-[-50%] w-[13px] h-[13px]"
                  alt="link"
                />
              </a>
            </div>
          )}
          {researcherIdUrl && (
            <div className="relative w-[158px] bg-[#F3F5F9] rounded-[12px] p-[6px]" style={{ pointerEvents: 'auto' }}>
              <a
                href={researcherIdUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[5px]"
                onMouseDown={(e) => { try { e.stopPropagation(); } catch { } }}
                onClick={(e) => { try { e.stopPropagation(); } catch { } }}
              >
                <img
                  src={`${rmVars.themeUrl}images/wos-page.png`}
                  className="w-[21px] h-[21px]"
                  alt="WoS ID icon"
                />
                <span className="text-[12px] text-[#555] font-semibold">WoS ID</span>
                <img
                  src={`${rmVars.themeUrl}images/launch-ico-555.png`}
                  className="absolute right-[6px] top-[50%] translate-y-[-50%] w-[13px] h-[13px]"
                  alt="link"
                />
              </a>
            </div>
          )}
          {googleUrl && (
            <div className="relative flex items-center gap-[5px] w-[158px] bg-[#F3F5F9] rounded-[12px] p-[6px]" style={{ pointerEvents: 'auto' }}>
              <a
                href={googleUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[5px]"
                onMouseDown={(e) => { try { e.stopPropagation(); } catch { } }}
                onClick={(e) => { try { e.stopPropagation(); } catch { } }}
              >
                <img
                  src={`${rmVars.themeUrl}images/googlescholar-page.png`}
                  className="w-[21px] h-[21px]"
                  alt="google scholar icon"
                />
                <span className="text-[12px] text-[#555] font-semibold">Google Scholar</span>
                <img
                  src={`${rmVars.themeUrl}images/launch-ico-555.png`}
                  className="absolute right-[6px] top-[50%] translate-y-[-50%] w-[13px] h-[13px]"
                  alt="link"
                />
              </a>
            </div>
          )}
          {isniUrl && (
            <div className="relative flex items-center gap-[5px] w-[158px] bg-[#F3F5F9] rounded-[12px] p-[6px]" style={{ pointerEvents: 'auto' }}>
              <a
                href={isniUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[5px]"
                onMouseDown={(e) => { try { e.stopPropagation(); } catch { } }}
                onClick={(e) => { try { e.stopPropagation(); } catch { } }}
              >
                <img
                  src={`${rmVars.themeUrl}images/isni-page.png`}
                  className="w-[21px] h-[21px]"
                  alt="isni icon"
                />
                <span className="text-[12px] text-[#555] font-semibold">ISNI</span>
                <img
                  src={`${rmVars.themeUrl}images/launch-ico-555.png`}
                  className="absolute right-[6px] top-[50%] translate-y-[-50%] w-[13px] h-[13px]"
                  alt="link"
                />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthorPopover;
